<template>
  <div id="SocialBill">
    <div class="page-header">
      <p class="page-path">
        账单管理<span class="slashline">/</span>应付台账<span
          class="slashline"
          >/</span
        >台账详情
      </p>
      <p class="page-title">开户台账详情</p>
    </div>
    <div class="operation-pannel">
       <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="basic-info">基础信息</div>
          </template>
          <el-form
            :model="basicInfoForm"
            label-position="top"
            ref="basicInfoForm"
            class="basic-info-form"
            :rules="basicInfoFormRules"
          >
            <el-row :gutter="30">
              <el-col :span="8">
                <el-form-item prop="enterpriseName">
                  <label style="text-align:right">单位名称</label>
                  <el-input
                    :span="3"
                    v-model="basicInfoForm.enterpriseName"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
               <el-col :span="8">     
                <el-form-item prop="billType">
                  <label >费用类型</label>
                  <el-select
                    v-model="basicInfoForm.costType"
                    placeholder="请选择"
                    clearable
                    :disabled="true"
                  >
                    <el-option label="社保开户费用" :value="1"></el-option>
                    <el-option label="公积金开户费用" :value="2"></el-option>
                    <el-option label="社保和公积金开户费用" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="customer">
                  <label style="text-align:right">所属客户</label>
                  <el-input
                    :span="3"
                    v-model="basicInfoForm.customer"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row :gutter="30">
                <el-col :span="8">     
                <el-form-item prop="branch">
                  <label >开户网点</label>
                  <el-input
                    v-model="basicInfoForm.branch"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">     
                <el-form-item prop="billType">
                  <label >台账类型</label>
                  <el-select
                    v-model="basicInfoForm.billType"
                    placeholder="请选择"
                    clearable
                    :disabled="true"
                  >
                    <el-option label="开户应付台账" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="creationTime">
                   <label >台账生成时间</label>
                 <el-date-picker
                  :editable="true"
                  :disabled="true"
                  v-model="basicInfoForm.creationTime"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder=""
                >
                </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
               <el-col :span="8">
                <el-form-item prop="id">
                  <label style="text-align:right">账单编号</label>
                  <el-input
                    :span="3"
                    v-model="basicInfoForm.id"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">     
                <el-form-item prop="totalCost">
                  <label >开户费用</label>
                  <el-input
                    v-model="basicInfoForm.totalCost"
                    placeholder=""
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="bottom-btn-group">
      <el-button type="info" @click="returnGeneralList">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateInfo",
  components: {},
  data: function () {
    return {
      activeNames: ["1","2"],
      selectedRegion: [],
      checkType:false,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      basicInfoForm: {
        enterpriseName:"",
        branch:"",
        city:"",
        customer:"",
        billType:0,
        month:"",
        totalCost:0,
        id:"",
        count:0,
        creationTime:"",
      },
      basicInfoFormRules: {
      },
      activeCard: "正常",
      savingTemplate: false, // 保存
      fanyouStorageDialog: false,
      fanyouStorageFilterForm: {
        Name: "",
      },
      filters:{
        joinType:"",
        nameOrIdCard:"",
      },
      tableLoading: false,
      linkingTotable: false,
    };
  },
  activated() {
    //获取明细
    console.log("获取信息");
    this.getBillInfo();
  },
  methods: {
    returnGeneralList() {
      this.$router.push("/CostBillList");
      this.basicInfoForm ={}
    },
    async getBillInfo() {
      let bid = this.$route.params.bid;
      try {
        let res = await this.$api.SaleBill.SaleOpenBillInfo(bid);
        if (res.code==200) {
          this.basicInfoForm = res.data;
          //如有需要，在这重新赋值
          //this.GetcheckType();
        } else {
          this.$message.error("获取详情失败！");
        }
      } catch (e) {
        console.log(e);
        this.$message.error("获取详情失败！");
      }
    }
  
  },

}
</script>


<style src="@/assets/public.css"></style>
<style scoped>
#addGeneralPolicy {
  padding: 20px;
}
.basic-info {
  width: 100%;
  font-size: 14px;
  background: #fafafa;
  padding: 0 20px;
  border-radius: 2px 2px 0 0;
  border-bottom: 1px solid #ededed;
}
.el-collapse {
  border-top: 0;
}
.basic-info-form {
  padding: 20px 20px 0;
}
.basic-info-form .el-select {
  width: 100%;
}
.basic-info-form .el-date-editor {
  width: 100%;
}
.policy-info {
  margin: 20px 0 0;
}
.control-panel {
  width: 100%;
  height: 48px;
  background: #fafafa;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px solid #ededed;
  box-sizing: border-box;
}
.uploadfileName {
  margin-left: 8px;
}
</style>
